import { render, staticRenderFns } from "./payFeeConfigDiscountManageList.vue?vue&type=template&id=0a9a288c&scoped=true"
import script from "./payFeeConfigDiscountManageList.vue?vue&type=script&lang=js"
export * from "./payFeeConfigDiscountManageList.vue?vue&type=script&lang=js"
import style0 from "./payFeeConfigDiscountManageList.vue?vue&type=style&index=0&id=0a9a288c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9a288c",
  null
  
)

export default component.exports